<template>
	<div>
		<div class="font-weight-bold mb-2">1. Teritorinė aprėptis</div>
		<div class="ml-2">
			<div class="d-flex align-center">
				<v-btn
					icon
					v-on:click="toggleExtentDrawing"
					:class="[extendDrawingActive ? 'extent-drawing-active' : '']"
					:disabled="termsAndConditionsVisible"
				>
					<v-icon title="Aktyvuoti teritorinės aprėpties braižymo įrankį">mdi-select</v-icon>
				</v-btn>
				<span class="pl-1">Žemėlapyje nurodyti teritorinę aprėptį</span>
			</div>
			<div class="mt-1 d-flex align-center" v-if="extentFeature">
				<v-btn
					icon
					v-on:click="clearPrintExtent"
					:disabled="termsAndConditionsVisible"
				>
					<v-icon title="Šalinti teritorinę aprėptį">mdi-select-off</v-icon>
				</v-btn>
				<span class="pl-1">Šalinti aprėptį</span>
			</div>
		</div>
		<div class="font-weight-bold mb-2 mt-4">2. Mastelis</div>
		<div class="ml-2">
			<v-select
				:items="scales"
				v-model="selectedScale"
				hide-details
				dense
				item-value="value"
				item-text="text"
				class="ml-2"
				:disabled="termsAndConditionsVisible"
			></v-select>
		</div>
		<div class="font-weight-bold mb-2 mt-8">3. Lapo formatas ir orientacija</div>
		<div class="ml-2">
			<v-select
				:items="paperSizes"
				v-model="selectedPaperSize"
				hide-details
				dense
				item-value="value"
				item-text="text"
				class="ml-2"
				:disabled="termsAndConditionsVisible"
			></v-select>
		</div>
		<div class="font-weight-bold mb-2 mt-8">4. Papildomi elementai</div>
		<div class="ml-4">
			<v-checkbox
				label="Titulinis puslapis"
				dense
				v-model="titlePage"
				hide-details
				class="mt-0"
			></v-checkbox>
			<v-checkbox
				label="Orientacinis žemėlapis (neįgyvendintas)"
				dense
				hide-details
				:disabled="true"
				class="mt-0 d-none"
			></v-checkbox>
			<v-checkbox
				label="Žemėlapio suskaidymo į lapus schema"
				dense
				v-model="indexMapPage"
				hide-details
				class="mt-0"
			></v-checkbox>
		</div>
		<div class="mt-6">
			<template v-if="termsAndConditionsVisible">
				<div class="terms-and-conditions pt-5">
					<v-checkbox
						dense
						v-model="termsAndConditions"
						hide-details
						class="mt-0"
						:disabled="printInAction"
					>
						<template v-slot:label>
							<span>Su žemėlapių rinkinio <a href="#" @click="showFullTermsAndConditions">naudojimosi sąlygomis</a> sutinku</span>
						</template>
					</v-checkbox>
					<div class="mt-4">
						<v-btn
							small
							:disabled="!termsAndConditions"
							v-on:click="generatePrintableAtlas"
							class="mr-2"
							:loading="printInAction"
						>
							Formuoti žemėlapių rinkinį
						</v-btn>
						<v-btn
							small
							v-on:click="rejectTermsAndConditions"
							:disabled="printInAction"
						>
							Atšaukti
						</v-btn>
					</div>
				</div>
			</template>
			<template v-else>
				<v-btn
					small
					:disabled="!valid"
					v-on:click="showTermsAndConditions"
				>
					Formuoti žemėlapių rinkinį
				</v-btn>
			</template>
		</div>
		<v-dialog
			persistent
			max-width="600"
			v-model="dialog"
		>
			<v-card v-if="url">
				<v-card-title>
					<span>Žemėlapių rinkinys</span>
				</v-card-title>
				<v-card-text>
					<a :href="url" target="_blank">Nuoroda į žemėlapių rinkinį</a>
				</v-card-text>
				<v-card-actions class="mx-4 pb-5">
					<v-btn
						color="blue darken-1"
						text
						v-on:click="closeDialog"
						outlined
						small
					>
						Uždaryti
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			persistent
			max-width="900"
			v-model="fullTermsAndConditionsDialog"
		>
			<v-card>
				<v-card-title class="fullTermsAndConditionsTitle mb-2">
					<span class="pt-1">Naudojimosi sąlygos</span>
				</v-card-title>
				<v-card-text>
					<p>Jūs naudojatės Lietuvos erdvinės informacijos portalo  žemėlapių lapų rinkinio (atlaso) kūrimo įrankiu.</p>
					<p>Jūsų sukurtas žemėlapių lapų rinkinys bus išvestinis produktas, kuriame greičiausiai panaudosite skirtingų teikėjų erdvinius duomenis ir žemėlapio paslaugas.</p> 
					<p>Išvestinį produktą galite platinti tik nepažeisdami jame panaudotų erdvinių duomenų rinkinių naudojimo sąlygų. Jei duomenys nebuvo atskirai užsakyti, jie platinami pagal <a href="https://www.geoportal.lt/geoportal/bendrosios-erdviniu-duomenu-naudojimo-salygos" target="_blank">Bendrąsias erdvinių duomenų naudojimo sąlygas</a>. Užsakomi duomenys naudojami pagal konkretaus erdvinių duomenų rinkinio ar paslaugos užsakymo metu patvirtintas duomenų naudojimo sutarties sąlygas.  Prašome atkreipti dėmesį, kad jei numatote platinti sukurtą  žemėlapių lapų rinkinį, privalote jo tituliniame puslapyje įrašyti kiekvieno panaudoto erdvinių duomenų rinkinio pavadinimą ir metus. Toks  reikalavimas netaikomas naudojant atvirus erdvinių duomenų rinkinius, tačiau nurodyti duomenų šaltinį ir šiuo atveju yra gera praktika. Jei sukurtą žemėlapių lapų rinkinį platinsite  komerciniais tikslais (gausite pelną), prašome įsitikinti, kad visus panaudotus erdvinių duomenų rinkinius galima naudoti komerciniais tikslais. Ši informacija nurodyta erdvinių duomenų rinkinių metaduomenų  dokumentų srityje „Apribojimai“.</p> 
					<p>Jei platinsite sukurtą žemėlapių lapų rinkinį, kuriame galima pamatyti asmens duomenis, atkreipiame dėmesį, kad tai darote savo atsakomybe, o naudodami kitų subjektų asmens duomenis privalote laikytis ES <a href="https://eur-lex.europa.eu/legal-content/LT/TXT/HTML/?uri=CELEX:32016R0679" target="_blank">Bendrojo duomenų apsaugos reglamento reikalavimų.</a></p>
					<p>
						<v-checkbox
							label="Susipažinau"
							dense
							v-model="agreeWithFullTermsAndConditions"
							hide-details
							class="mt-0 pa-0 d-none"
						></v-checkbox>
					</p>
					<p>Kviečiame kurti kokybiškus erdvinių duomenų produktus ir jais dalintis!</p>
				</v-card-text>
				<v-card-actions class="mx-4 pb-5">
					<v-btn
						color="blue darken-1"
						text
						v-on:click="fullTermsAndConditionsDialog = false"
						outlined
						small
					>
						Uždaryti
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import CommonHelper from "../../../../../components/helpers/CommonHelper";
	import VectorSource from "ol/source/Vector";
	import VectorLayer from "ol/layer/Vector";
	import {Stroke, Style, Fill, Text as TextStyle} from "ol/style";
	import Draw, {createBox} from "ol/interaction/Draw";
	import MapHelper from "../../../../../components/helpers/MapHelper";
	import PrintableAtlasHelper from "../../../../../components/helpers/PrintableAtlasHelper";
	import {getHeight, getWidth, getTopLeft, getTopRight, getBottomLeft, getBottomRight} from "ol/extent";
	import Point from "ol/geom/Point";
	import Polygon from "ol/geom/Polygon";
	import Feature from "ol/Feature";
	import DoubleClickZoom from "ol/interaction/DoubleClickZoom";
	import PinchZoom from "ol/interaction/PinchZoom";
	import KeyboardZoom from "ol/interaction/KeyboardZoom";
	import MouseWheelZoom from "ol/interaction/MouseWheelZoom";
	import DragZoom from "ol/interaction/DragZoom";
	import {OverviewMap} from "ol/control";
	import MultiLineString from "ol/geom/MultiLineString";

	export default {
		data: function(){
			var data = {
				scales: [{
					text: "1:500",
					value: "500"
				},{
					text: "1:1 000",
					value: "1000"
				},{
					text: "1:2 000",
					value: "2000"
				},{
					text: "1:5 000",
					value: "5000"
				},{
					text: "1:10 000",
					value: "10000"
				},{
					text: "1:25 000",
					value: "25000"
				},{
					text: "1:50 000",
					value: "50000"
				},{
					text: "1:100 000",
					value: "100000"
				},{
					text: "1:250 000",
					value: "250000"
				},{
					text: "1:500 000",
					value: "500000"
				},{
					text: "1:1 000 000",
					value: "1000000"
				},{
					text: "1:2 000 000",
					value: "2000000"
				}],
				selectedScale: "50000",
				paperSizes: [{
					text: "A5 stačias",
					value: "a5portrait"
				},{
					text: "A5 gulsčias",
					value: "a5landscape"
				},{
					text: "A4 stačias",
					value: "a4portrait"
				},{
					text: "A4 gulsčias",
					value: "a4landscape"
				}],
				selectedPaperSize: "a4landscape",
				extentFeature: null,
				titlePage: false,
				indexMapPage: false,
				extendDrawingActive: false,
				valid: false,
				termsAndConditionsVisible: false,
				termsAndConditions: false,
				printInAction: false,
				url: null,
				dialog: false,
				fullTermsAndConditionsDialog: false,
				agreeWithFullTermsAndConditions: false
			};
			if (this.data.gridParams) {
				data.selectedScale = this.data.gridParams.scale;
				data.selectedPaperSize = this.data.gridParams.paperSize;
			}
			return data;
		},
		props: {
			data: Object
		},
		computed: {
			myMap: {
				get: function(){
					return this.data.myMap;
				}
			}
		},
		methods: {
			toggleExtentDrawing: function(){
				this.doToggleExtentDrawing(!this.extendDrawingActive);
			},
			doToggleExtentDrawing: function(status){
				this.extendDrawingActive = status;
				if (status) {
					if (!this.drawInteraction) {
						this.drawInteraction = new Draw({
							source: this.printExtentLayer.getSource(),
							type: "Circle",
							geometryFunction: createBox(),
							freehand: true
						});
						this.drawInteraction.on("drawend", function(e){
							this.drawPrintExtent(e.feature);
						}.bind(this));
						this.myMap.map.addInteraction(this.drawInteraction);
					}
				} else {
					this.myMap.map.removeInteraction(this.drawInteraction);
					this.drawInteraction = null;
				}
			},
			showTermsAndConditions: function(){
				this.termsAndConditions = false;
				this.termsAndConditionsVisible = true;
			},
			getPrintExtentLayerStyle: function(){
				var style = new Style({
					stroke: new Stroke({
						color: "red",
						width: 1
					}),
					fill: new Fill({
						color: "rgba(255, 0, 0, 0.1)"
					})
				});
				return style;
			},
			getPrintGridLayerStyle: function(){
				var styleFunction = function(feature){
					var style = {
						stroke: new Stroke({
							color: "#111111",
							width: 1.5
						})
					};
					if (feature.get("ignore")) {
						style.fill = new Fill({
							color: "rgba(255, 0, 0, 0.5)"
						});
					}
					style = new Style(style);
					return style;
				};
				return styleFunction;
			},
			drawPrintExtent: function(feature){
				this.clearPrintExtent(); // Gi aktualu pašalinti prieš tai nupieštą extent'o feature'į...
				this.doToggleExtentDrawing(false);
				this.extentFeature = feature;
				this.drawGrid();
			},
			clearPrintExtent: function(){
				if (this.printExtentLayer) {
					this.printExtentLayer.getSource().clear();
				}
				if (this.myMap.gridLayer) {
					this.myMap.gridLayer.getSource().clear();
				}
				this.valid = this.extentFeature = null;
			},
			drawGrid: function(ignoreCells){
				if (this.extentFeature) {
					this.extentFeature.set("grid-params", {
						scale: this.selectedScale,
						paperSize: this.selectedPaperSize,
						extentCoordinates: this.extentFeature.getGeometry().getCoordinates()
					});
					if (!this.myMap.gridLayer) {
						this.myMap.gridLayer = new VectorLayer({
							source: new VectorSource(),
							style: this.getPrintGridLayerStyle(),
							zIndex: 1001
						});
						this.myMap.map.addLayer(this.myMap.gridLayer);
					} else {
						this.myMap.gridLayer.getSource().clear();
					}
					var resolution = MapHelper.getResolutionForScale(this.selectedScale),
						valid = false;
					if (resolution) {
						var paperSizeMM = this.getPageSizeMM(this.selectedPaperSize),
							pageMarginMM = 10, // Po 1 cm iš visų pusių...
							dpi = 200,
							printableAreaDimensionsMM = [paperSizeMM[0] - 2*pageMarginMM, paperSizeMM[1] - 2*pageMarginMM],
							extent = this.extentFeature.getGeometry().computeExtent(),
							printableAreaDimensionPixels = [Math.round(printableAreaDimensionsMM[0]*dpi/25.4), Math.round(printableAreaDimensionsMM[1]*dpi/25.4)],
							xStepMeters = printableAreaDimensionPixels[0]*resolution*96/dpi,
							yStepMeters = printableAreaDimensionPixels[1]*resolution*96/dpi,
							dXMeters = getWidth(extent),
							dYMeters = getHeight(extent),
							xCount = Math.floor(dXMeters/xStepMeters) + 1,
							yCount = Math.floor(dYMeters/yStepMeters) + 1,
							pagesCount = xCount*yCount,
							maxPagesCount = 100;
						if (pagesCount > maxPagesCount) {
							// TODO: pranešti vartotojui, kad grid'o išpaišyti negalima...
							this.$vBus.$emit("show-message", "Maksimalus galimas lapų skaičius: " + maxPagesCount + "!");
						} else {
							var x,
								y,
								feature,
								features = [],
								pos;
							for (var i = 0; i < xCount; i++) {
								x = extent[0] + i*xStepMeters;
								for (var j = 0; j < yCount; j++) {
									y = extent[3] - j*yStepMeters;
									feature = new Feature({
										geometry: new Polygon([[
											[x, y], [x + xStepMeters, y], [x + xStepMeters, y - yStepMeters], [x, y - yStepMeters], [x, y]
										]])
									});
									pos = [j, i];
									feature.set("pos", pos);
									if (ignoreCells && ignoreCells.indexOf(pos.join("-")) > -1) {
										feature.setProperties({
											"ignore": true,
											"ignoredFeature": this.addIgnoreCellFeature(feature)
										});
									}
									features.push(feature);
								}
							}
							this.myMap.gridLayer.getSource().addFeatures(features);
							valid = true;
							this.xStepMeters = xStepMeters; // Prireiks zoom'inant prie pirmosios ląstelės...
							this.yStepMeters = yStepMeters; // Prireiks zoom'inant prie pirmosios ląstelės...
						}
						var coordinates = [extent[0] + xCount*xStepMeters, extent[3] - yCount*yStepMeters];
						this.valid = valid;
						this.drawPagesCountFeature(pagesCount, coordinates);
						// Čia šito prireikė po to:
						this.printParameters = {
							xTop: extent[0],
							yTop: extent[3],
							xStep: xStepMeters,
							yStep: yStepMeters,
							xCount: xCount,
							yCount: yCount,
							printableAreaDimensionPixels: printableAreaDimensionPixels,
							dpi: dpi
						}
					} else {
						// Taip neturėtų būti...
					}
				}
			},
			getPageSizeMM: function(pageSize){
				var pageSizesMM = {
					a5portrait: [148, 210],
					a5landscape: [210, 148],
					a4portrait: [210, 297],
					a4landscape: [297, 210]
				};
				return pageSizesMM[pageSize];
			},
			drawPagesCountFeature: function(pagesCount, coordinates){
				var pagesCountFeature = new Feature({
					geometry: new Point(coordinates)
				});
				pagesCountFeature.setStyle(new Style({
					text: new TextStyle({
						text: pagesCount + "",
						font: "bold 16px sans-serif",
						textAlign: "left",
						offsetX: 8,
						offsetY: 8,
						fill: new Fill({
							color: this.valid ? "rgba(0, 0, 0)" : "rgba(255, 0, 0)"
						})
					})
				}));
				this.myMap.gridLayer.getSource().addFeature(pagesCountFeature);
			},
			rejectTermsAndConditions: function(){
				this.termsAndConditionsVisible = false;
			},
			generatePrintableAtlas: function(){
				// TODO nagrinėti: getPdfGenerationParams()
				// Bandyti su https://apptest/inspire-widgets/v2/atlas/413373e2-f720-4aaf-bb65-03752c33f9a9/edit
				this.printInAction = true;
				if (this.extentFeature) {
					var gridParams = this.extentFeature.get("grid-params");
					if (gridParams && this.printParameters) {
						var params = {
							title: this.data.atlasData.title,
							description: this.data.atlasData.shortDescription,
							sources: this.data.atlasData.sources,
							copyright: this.data.atlasData.copyright,
							metaPage: this.titlePage,
							indexPage: this.indexMapPage,
							pageFormat: gridParams.paperSize,
							mapScale: gridParams.scale
						};
						params = Object.assign(this.printParameters, params);
						var atlasId = this.getAtlasId();
						if (atlasId) {
							params.atlasID = atlasId;
							PrintableAtlasHelper.doJob(params, this.myMap).then(function(url){
								if (url) {
									this.url = url;
									this.dialog = true;
								} else {
									this.$vBus.$emit("show-message", "error");
								}
								this.printInAction = false;
							}.bind(this), function(){
								this.printInAction = false;
								this.$vBus.$emit("show-message", "error");
							}.bind(this));
						}
					}
				}
			},
			toggleOverviewMap: function(val){
				// https://openlayers.org/en/latest/examples/Overviewmap-custom.html
				if (val) {
					if (!this.overviewMapControl) {
						this.overviewMapControl = new OverviewMap({
							layers: [this.myMap.gridLayer],
							className: "ol-overviewmap ol-custom-overviewmap",
							collapseLabel: "\u00BB",
							label: "\u00AB",
							collapsed: false
						});
						this.myMap.map.addControl(this.overviewMapControl);
					}
				} else {
					if (this.overviewMapControl) {
						this.myMap.map.removeControl(this.overviewMapControl);
						this.overviewMapControl = null;
					}
				}
			},
			doClick: function(e){
				var feature;
				if (this.myMap.gridLayer) {
					var features = this.myMap.gridLayer.getSource().getFeaturesAtCoordinate(e.coordinate);
					if (features.length && features.length == 1) {
						feature = features[0];
						var nowIgnored = feature.get("ignore"),
							ignoredFeature;
						if (nowIgnored) {
							var currentIgnoredFeature = feature.get("ignoredFeature");
							if (currentIgnoredFeature) {
								this.myMap.gridLayer.getSource().removeFeature(currentIgnoredFeature);
							}
						} else {
							ignoredFeature = this.addIgnoreCellFeature(feature);
						}
						feature.setProperties({
							"ignore": !nowIgnored,
							"ignoredFeature": ignoredFeature
						});
					}
				}
				if (!feature) {
					this.myMap.doIdentify(e);
				}
			},
			addIgnoreCellFeature: function(feature){
				var extent = feature.getGeometry().getExtent(),
					topLeft = getTopLeft(extent),
					topRight = getTopRight(extent),
					bottomLeft = getBottomLeft(extent),
					bottomRight = getBottomRight(extent),
					ignoredFeature = new Feature({
						geometry: new MultiLineString([[topLeft, bottomRight], [topRight, bottomLeft]])
					});
				this.myMap.gridLayer.getSource().addFeature(ignoredFeature);
				return ignoredFeature;
			},
			closeDialog: function(){
				this.dialog = false;
				this.url = null;
			},
			getAtlasId: function(){
				var path = this.$router.history.current.path,
					atlasPathData = CommonHelper.getAtlasPathData(path),
					atlasId;
				if (atlasPathData) {
					atlasId = atlasPathData[0];
				}
				return atlasId;
			},
			showFullTermsAndConditions: function(e){
				e.preventDefault();
				e.stopPropagation();
				this.fullTermsAndConditionsDialog = true;
			}
		},
		created(){
			if (!this.printExtentLayer) {
				this.printExtentLayer = new VectorLayer({
					source: new VectorSource(),
					style: this.getPrintExtentLayerStyle(),
					zIndex: 1002
				});
				this.myMap.map.addLayer(this.printExtentLayer);
			}
			if (this.data && this.data.gridParams && this.data.gridParams.extentCoordinates) {
				this.extentFeature = new Feature({
					geometry: new Polygon(this.data.gridParams.extentCoordinates)
				});
				this.printExtentLayer.getSource().addFeature(this.extentFeature);
				this.drawGrid(this.data.gridParams.ignore);
			}
			this.myMap.identifySuspended = true;
			this.myMap.map.on("click", this.doClick);
		},
		watch: {
			selectedScale: {
				handler: function(){
					this.drawGrid();
				}
			},
			selectedPaperSize: {
				handler: function(){
					this.drawGrid();
				}
			},
			termsAndConditionsVisible: {
				handler: function(val){
					var toggleInteractions;
					if (val) {
						var resolution = MapHelper.getResolutionForScale(this.selectedScale);
						if (resolution) {
							this.myMap.map.getView().setResolution(resolution);
							toggleInteractions = true;
							var features = this.printExtentLayer.getSource().getFeatures();
							if (features.length) {
								var coordinates = getTopLeft(features[0].getGeometry().getExtent());
								coordinates[0] += this.xStepMeters/2;
								coordinates[1] -= this.yStepMeters/2;
								this.myMap.map.getView().animate({
									center: coordinates,
									duration: 500
								});
							}
						}
					} else {
						toggleInteractions = true;
					}
					this.toggleOverviewMap(val);
					if (toggleInteractions) {
						this.myMap.map.getInteractions().forEach(function(interaction){
							if (interaction instanceof DoubleClickZoom || interaction instanceof PinchZoom || interaction instanceof KeyboardZoom || interaction instanceof MouseWheelZoom || interaction instanceof DragZoom) {
								interaction.setActive(!val);
							}
						}.bind(this));
						
					}
				}
			},
			extentFeature: {
				handler: function(val){
					this.myMap.printExtentFeature = val;
				}
			}
		}
	};
</script>

<style scoped>
	.v-select {
		max-width: 250px;
	}
	.extent-drawing-active {
		background-color: #e2e2e2;
	}
	.terms-and-conditions {
		border-top: solid 2px #ccc;
	}
	.fullTermsAndConditionsTitle {
		line-height: 1.2 !important;
	}
</style>